import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CodedResponseModel } from "src/app/model/CodedResponseModel";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn:'root'
})
export class GlobalsAPI{
    constructor(
        private http:HttpClient,
    ){}

    public loginData(){
        return this.http.get<CodedResponseModel>(`${environment.apiUrl}login_data`);
    }
    public set(data:any){
        return this.http.put<CodedResponseModel>(`${environment.apiUrl}set`,
            data);
    }
}
